import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73a1b814"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center text-2xl font-bold" }, "nonnish greebles", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xl" }, "adoption center open", -1))
const _hoisted_3 = { class: "text-center text-lg text-primary font-bold" }
const _hoisted_4 = { class: "grid grid-cols-5 gap-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/example.png",
  alt: "Greebles Logo",
  class: "rounded col-span-2 w-64"
}, null, -1))
const _hoisted_6 = { class: "flex flex-col items-center justify-center gap-4 col-span-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "price per greeble", -1))
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "grid grid-cols-3 sm:grid-cols-4 gap-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_11 = { class: "sm:col-span-2 text-center px-4 py-2 rounded border bg-white disabled:bg-gray-500" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-end col-span-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, "total")
], -1))
const _hoisted_15 = { class: "col-span-2 text-center px-4 py-2 rounded border bg-white disabled:bg-gray-500" }
const _hoisted_16 = { class: "flex justify-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col space-y-4" }, null, -1))

import VButton from "@/components/VButton.vue";
import { signContract } from "@/services/stacks";
import { ref, computed } from "vue";
import { useAuthStore } from "@/stores/authStore";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const contractValues = {
  claim: 1,
  "claim-two": 2,
  "claim-three": 3,
  "claim-four": 4,
  "claim-five": 5,
};
const functions = Object.keys(contractValues);

const mintCount = ref(1);
const displayPrice = computed(() => {
  const store = useAuthStore();
  return store.price / 1000000;
});

const lastId = computed(() => useAuthStore().lastId);
const availability = computed(() => useAuthStore().availability);
const balance = computed(() => useAuthStore().balance);

const maxAvailableToMint = computed(() => {
  const remaining = 2000 - lastId.value;
  const maxAllowed = availability.value == "private" ? balance.value : 5;
  return Math.min(maxAllowed, remaining, 5);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(lastId)) + " / 1000 minted ", 1),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(displayPrice)) + " stx each", 1),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(VButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (mintCount.value--)),
            disabled: mintCount.value <= 1
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(mintCount.value), 1),
          _createVNode(VButton, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (mintCount.value++)),
            disabled: mintCount.value >= _unref(maxAvailableToMint)
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        (_unref(availability) == 'private')
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(balance)) + " / greebles available to claim", 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, _toDisplayString(mintCount.value * _unref(displayPrice)) + " STX ", 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("img", {
        style: {"cursor":"pointer"},
        src: require('@/assets/mint.png'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(signContract)(_unref(functions)[mintCount.value - 1], mintCount.value)))
      }, null, 8, _hoisted_17)
    ]),
    _hoisted_18
  ], 64))
}
}

})